var render = function render(_c,_vm){return _c('h1',{staticClass:"one-hidden-h1"},[_vm._v(_vm._s(_vm.props.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }